import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=75fd8ccb&scoped=true&"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fd8ccb",
  null
  
)

export default component.exports